import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { apiLogger } from './utils/apiLogger'
import { initOneSignal } from './config/onesignal'

try {
  apiLogger.initialize()
} catch (error) {}

// Clean up old root-scoped OneSignal service worker, then init OneSignal after PLuG loads
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => {
      if (reg.active?.scriptURL?.includes('OneSignalSDKWorker') && reg.scope === `${window.location.origin}/`) {
        reg.unregister()
      }
    })
  })
}
setTimeout(() => { initOneSignal() }, 5000)

// Mount React app
const root = document.getElementById('root')
if (root && !root._reactRootContainer) {
  ReactDOM.createRoot(root).render(
    <App />
  )
}